import React from 'react';
import Paper, { type PaperProps } from '@mui/material/Paper';
import { useTheme } from '../../context/ThemeContext';

export interface CardContainerProps extends Omit<PaperProps, 'elevation'> {
  /** Disable hover effect */
  disableHover?: boolean;
}

const CardContainer: React.FC<CardContainerProps> = ({
  children,
  disableHover = false,
  sx,
  ...props
}) => {
  const { theme } = useTheme();
  const card = theme.components.card;

  return (
    <Paper
      elevation={0}
      data-testid="card-container"
      sx={{
        backgroundColor: card.background,
        border: `1px solid ${card.border}`,
        borderRadius: '12px',
        overflow: 'hidden',
        transition: 'all 0.2s ease',
        ...(card.shadow && { boxShadow: card.shadow }),
        ...(!disableHover && {
          '&:hover': {
            backgroundColor: card.hover,
            ...(card.hoverShadow && { boxShadow: card.hoverShadow }),
          },
        }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default CardContainer;
